import { useMutation } from "@tanstack/react-query";
import { getAdminRaffleRoundsPublicIdTicketsTicketNumberHolder } from "Infrastructure/Api/Api";
import { processResponseWithApiProblemDetails } from "Infrastructure/Api/ApiUtils";

type LookupParams = {
  roundPublicID: string;
  ticketNumber: number;
};

/** A mutation, not a query: each press is one audited BE call, never cached or refetched. */
export const useRaffleTicketHolderLookupMutation = () =>
  useMutation({
    mutationFn: processResponseWithApiProblemDetails(
      ({ roundPublicID, ticketNumber }: LookupParams) =>
        getAdminRaffleRoundsPublicIdTicketsTicketNumberHolder(
          roundPublicID,
          ticketNumber,
        ),
    ),
    // Personal data: dropped as soon as the closed dialog unmounts its content.
    gcTime: 0,
    retry: false,
  });
